import React, {useContext, useEffect, useRef, useState} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";
import projectUtils from "../../../../../utils/project-utils.js";
import Button from "../../../../../components/button/button.jsx";
import {FaTimes} from "react-icons/fa";
import {IndividualContext} from "../individual-context.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ProfilePicture = () => {
    const {individual, setIndividual, setFaceFile, setAttachList, attachList} = useContext(IndividualContext)
    const imgRef = useRef(null);
    const triggerInput = () => imgRef.current?.click();
    const [open, setOpen] = useState(false);
    const [imgScr, setImgScr] = useState(undefined);

    const attachUserImage = ({target: {files}}) => {
        const file = files[0];
        const reader = new FileReader();

        if (file.size >= 2000000) {
            let message = 'Tamanho máximo de arquivo excedido. Limite: 2MB.';
            projectUtils.swalErrorMessage('', message, 'Ok');
            return;
        }

        reader.onload = function (e) {
            setImgScr(e.target.result);
        }

        reader.readAsDataURL(file);

        setIndividual(prev => ({...prev, relatedPhotoFaceId: null}))
        // setAttachList(prev => prev.filter(a => a.attachId !== individual.relatedPhotoFaceId))
        setFaceFile(file)
    }

    const removeFile = () => {
        setImgScr(null);
        setIndividual(prev => ({...prev, relatedPhotoFaceId: null}))
        setFaceFile(null)
        // setAttachList(prev => prev.filter(a => a.attachId !== individual.relatedPhotoFaceId))
    }

    const openModal = ({target}) => {
        if ((!individual.relatedPhotoFaceId && !imgScr) || target.classList.contains("btn-danger") || target.classList.contains("fa-close")) return;
        setOpen(true);
    }

    const getBg = () => {
        switch (individual.situation) {
            case "PROCURADO": return "bg-[#ef7d00]"
            case "FORAGIDO": return "bg-[#b10919]"
            case "SOLTO": return "bg-[#1b6ea2]"
            case "MORTO": return "bg-[#000]"
            default: return "bg-[#343a40]"
        }
    }

    const getDatePhoto = (fromModal = false) => {
        const datePhotoFace = attachList.find(a => a.attachId === individual.relatedPhotoFaceId)?.datePhotoFace

        if (!datePhotoFace) {
            if (fromModal) return <p>Foto</p>

            return ""
        }

        return (<small>Data da foto: {projectUtils.formatDate(datePhotoFace, 'DD/MM/YYYY')}</small>)
    }

    return (
        <>
            <Card className={"mb-2"}>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <div className="relative">
                                {
                                    (individual.relatedPhotoFaceId || imgScr) &&
                                    <Button target={"danger"} className={"absolute w-6.25! h-6.25! p-0! right-1.25 top-1.25"} onClick={() => removeFile()} title="Remover imagem">
                                        <FaTimes />
                                    </Button>
                                }
                                <div className="overflow-hidden h-[158px] bg-center bg-no-repeat bg-contain cursor-pointer border border-[#e0e0e0] rounded p-1" id="image-user" onClick={openModal}
                                     style={{
                                         backgroundImage: individual.relatedPhotoFaceId ? `url(${API_KEEPER}/ged/attach/${individual?.relatedPhotoFaceId})` : imgScr ? `url(${imgScr})` : `url(${getAssetPath("img/user.png")})`,
                                     }}
                                ></div>
                                <input type="hidden" name="imageId" value={individual.relatedPhotoFaceId ?? ""}/>
                                <input type="file" accept="image/png, image/jpeg" className="hidden" name="image" onChange={attachUserImage}
                                       ref={imgRef}/>
                                <Button className={"w-full"} onClick={triggerInput}>
                                    <span>Selecionar foto</span>
                                </Button>
                                <div className={"flex justify-between"}>

                                    <small>* Tamanho máximo 2MB</small>

                                    {getDatePhoto()}
                                </div>

                                {
                                    !!individual.situation &&
                                    <span className={`text-center ${getBg()} text-white font-bold absolute bottom-11.25 px-3 py-1.25 rounded-[5px] left-1/2 -translate-x-1/2 -translate-y-1/2`}>{individual.situation}</span>
                                }
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} onClick={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false} title={getDatePhoto(true)}>
                <Modal.Body className="p-2">
                    <div className={"bg-center bg-no-repeat bg-contain overflow-hidden h-[500px]"} style={{
                        backgroundImage: individual.relatedPhotoFaceId ? `url(${API_KEEPER}/ged/attach/${individual?.relatedPhotoFaceId})` : imgScr ? `url(${imgScr})` : `url(${getAssetPath("img/user.png")})`,
                    }}
                    ></div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProfilePicture;